import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, Card } from "reactstrap"

class CardShop extends Component {
  render() {
    console.log('shop', this.props)
    const name = this.props.shop.name
    const {shop} = this.props;
    // const nameIcon = name.charAt(0)
    return (
      <React.Fragment>
        <Col xl="4" sm="6">
          <Card>
            <Row>
              <Col xl="5">
                <div className="text-center p-4 border-end">
                  <div className="avatar-sm mx-auto mb-3 mt-1">
                    <span
                      className={
                        "avatar-title rounded-circle bg-soft bg-" +
                        this.props.shop.color +
                        " primary text-" +
                        this.props.shop.color +
                        " font-size-16"
                      }
                    >
                      {/* {nameIcon} */}
                    </span>
                  </div>
                  <h5 className="text-truncate pb-1">{shop.store_name}</h5>
                  <small>{shop.tag_line}</small>
                </div>
              </Col>

              <Col xl="7">
                <div className="p-4 text-center text-xl-start">
                  <Row>
                    <Col xs="12">
                      <div>
                        <p className="text-muted mb-2 text-truncate">
                          Platform
                        </p>
                        <h5>{shop.platform.platform_name}</h5>
                      </div>
                    </Col>
                    <Col xs="12">
                      <div>
                        <p className="text-muted mb-2 text-truncate">
                          Store URL
                        </p>
                        <h5>{shop.store_url}</h5>
                      </div>
                    </Col>
                  </Row>
                  <div className="mt-4">
                    <Link to={"/store/"+shop.id} className="text-decoration-underline text-reset">
                      See Store Detail
                      <i className="mdi mdi-arrow-right"></i></Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </React.Fragment>
    )
  }
}

CardShop.propTypes = {
  shop: PropTypes.object
}

export default CardShop
